import { render, staticRenderFns } from "./DateDisplay.vue?vue&type=template&id=0555c2b2&scoped=true&"
import script from "./DateDisplay.vue?vue&type=script&lang=js&"
export * from "./DateDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0555c2b2",
  null
  
)

export default component.exports